import React from 'react';
import Banner from '../../../components/Banner/Banner';
import './Danismanlik.css';

const Danismanlik = () => {
  return (
    <div className="danismanlik-page">
      {/* Banner */}
      <Banner 
        title="Danışmanlık" 
        backgroundImage="https://teknoma.net/wp-content/themes/bizler/assets/img/inner-banner.jpg" 
      />

      {/* Page Content */}
      <section className="danismanlik-content">
        <div className="container content-container">
          
          {/* Consultancy Section */}
          <div className="section consultancy">
            <p>
              <strong>Proje Danışmanlığı:</strong><br />
              Teknoma tarafından çeşitli tip projelerin sürdürülmesi için danışmanlık hizmeti verilmektedir.
            </p>
            <p>
              <strong>Proje Hazırlama:</strong><br />
              Teknoma tarafından çeşitli tip projelerin hazırlanması için danışmanlık hizmeti verilmektedir.
            </p>
          </div>

          {/* National Projects Section */}
          <div className="section national-projects">
            <h4 className="section-heading">Ulusal Proje Sunulan Kurumlar:</h4>
            <ul>
              <li>TUBİTAK-TEYDEB</li>
              <li>KOSGEB</li>
              <li>TTGV</li>
            </ul>
          </div>

          {/* International Projects Section */}
          <div className="section international-projects">
            <h4 className="section-heading">Uluslararası Proje Sunulan Kurumlar:</h4>
            <ul>
              <li>ESF (Avrupa Bilim Fonu)</li>
              <li>FP7 Avrupa Cerceve Programı</li>
              <li>NATO</li>
            </ul>
          </div>
          
        </div>
      </section>
    </div>
  );
};

export default Danismanlik;
